import {Component} from '@angular/core';
import {WidgetsService} from '../../../widgets/services/widgets.service';
import {MemberService} from '../../../../services/member.service';
import {ActiveMenuModel} from '../../../../models/menu.model';
import {LayoutDataService} from '../../services/lyaout-data.service';
import {LayoutMenuService} from '../../services/lyaout-menu.service';
import {forkJoin, from, of, switchMap} from 'rxjs';
import {MatMenuTrigger} from '@angular/material/menu';
import {Router} from '@angular/router';

@Component({
    selector: 'app-m-layout-menu-full',
    templateUrl: './layout-menu-full.component.html',
    styleUrl: './layout-menu-full.component.scss',
    //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLayoutMenuFullComponent {
	public appMenu:ActiveMenuModel[]= []
	public openedMenuKey:string = 'null'
	public extendedMenuKey:string = 'null'
	public selectedMenuKeyMain:string = 'null'
	public selectedMenuKeyChild:string = 'null'
	constructor(
		public layoutDataService:LayoutDataService,
		public layoutMenuService:LayoutMenuService,
		private memberService: MemberService,
		private widgetService: WidgetsService,
		private router : Router
	) {	}
	ngOnInit(): void {
		from(this.memberService.getCurrentMember())
		.pipe(
			switchMap(member=>forkJoin([of(member),this.memberService.getMenu()])),
			switchMap(data=>this.layoutMenuService.prepareMenu(data[1].project_settings,data[0])),
		).subscribe(appMenu=>{this.appMenu = appMenu})
	}

	toggleExtendedMode(event:Event, menuItem:ActiveMenuModel) {
		event.stopPropagation()
		if (this.layoutDataService.bSubToggleMenuPanel.value) {
			if (this.extendedMenuKey === menuItem.menu_key) {
			 this.extendedMenuKey='null'
			} else {
				this.extendedMenuKey=menuItem.menu_key||'null' 
			} 
		}
	}

	openChildMenu(event:Event, menuTrigger: MatMenuTrigger, menuItem:ActiveMenuModel) {
    this.openedMenuKey = menuItem.menu_key||'null'
		if ( this.extendedMenuKey === menuItem.menu_key && this.layoutDataService.bSubToggleMenuPanel.value === true) {
			return
		}
		menuTrigger.menuData = {menuItem:menuItem}
		menuTrigger.openMenu()
	}

	closeChildMenu(event:MouseEvent,menuTrigger: MatMenuTrigger,menuItem:ActiveMenuModel) {
    event.stopPropagation()
    let enteredElement = event.relatedTarget as HTMLElement;
		if ( this.extendedMenuKey === menuItem.menu_key && this.layoutDataService.bSubToggleMenuPanel.value === true) {
			return
		}
		if (enteredElement?.className?.includes('panel-menu-child-item') === false ) {
			menuTrigger.closeMenu()
			this.openedMenuKey ='null'
    }
	}

	onOpenMenuItem(menuItemChild: ActiveMenuModel,menuItemParent:ActiveMenuModel,event?:PointerEvent) {
		if (this.extendedMenuKey !== menuItemParent.menu_key) {
			this.extendedMenuKey =  menuItemParent.menu_key||'null'
		}
		event? event.preventDefault() : null;
		event? event.stopPropagation() : null;
    this.selectedMenuKeyMain = menuItemParent.menu_key||'null'
    this.selectedMenuKeyChild = menuItemChild.key||'null'
		if (menuItemChild.isDisable) {
			return;
		}
		let query = {queryParams: {}};
		if (menuItemChild.queryParam) {
				query.queryParams = menuItemChild.queryParam;
		}
		if (menuItemChild.url) {
				this.router.navigate(menuItemChild.url, query);
				this.widgetService.subShowWidgets.next(false)
		}
	}

	toggleMenuPanel() {
		this.layoutDataService.bSubToggleMenuPanel.next(!this.layoutDataService.bSubToggleMenuPanel.value)
	}
	
	createWidgetInstruct() {
			this.widgetService.subWidgetNewCreate.next(true)
	}
}